var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLoopOff15X({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "21px",
    viewBox: "0 0 26 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2DF336F2-FC8B-4C16-AB29-A8A72AA4BEB7@1.5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Schools/Web-Player",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Schools/Lessons/Player",
    transform: "translate(-383.000000, -703.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Default/Loop",
    transform: "translate(384.000000, 704.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19,3 L2,3 C0.8954305,3 0,3.8954305 0,5 L0,9 L0,9",
    id: "Path-2",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,8.50925926 L5.26485149,8.50925926 C4.16028199,8.50925926 3.26485149,9.40468976 3.26485149,10.5092593 L3.26485149,16.1481481 L3.26485149,16.1481481",
    id: "Path-2",
    strokeLinecap: "round",
    transform: "translate(12.632426, 12.328704) scale(-1, -1) translate(-12.632426, -12.328704) "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    fill: "#FFFFFF",
    points: "22.5 3 18.5 5.5 18.5 0.5"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    fill: "#FFFFFF",
    transform: "translate(2.500000, 16.000000) scale(-1, 1) translate(-2.500000, -16.000000) ",
    points: "4.5 16 0.5 18.5 0.5 13.5"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoopOff15X);
export default __webpack_public_path__ + "static/media/LoopOff@1.5x.3d7437a264110a3116ead98632c23043.svg";
export { ForwardRef as ReactComponent };